<template>
  <Modal class="long-modal" width="900" style="max-height:80%; over-flow:auto"  v-model="show" :mask-closable="false" :loading="loading">
    <div slot="header" class="modal-header">{{'处理商机'}}</div>
    <Form :model="formData" :label-width="110" :rules="formRules" ref="formData" v-if="enumList ">
      <Row ::gutter="16">

        <Col span="12">
          <FormItem label="电话" prop="customerPhone" class="">
            <Input v-model="formData.customerPhone" class="item-width"></Input>
          </FormItem>
        </Col>
        <Col span="7">
          <FormItem label="姓名" prop="customerName">
            <Input v-model="formData.customerName" ></Input>
          </FormItem>
        </Col>
        <Col span="5">
          <FormItem label="" :label-width="22" prop="customerGender">
            <RadioGroup v-model="formData.customerGender">
              <Radio :label="'2'">
                <span>男</span>
              </Radio>
              <Radio :label="'1'">
                <span>女</span>
              </Radio>
            </RadioGroup>
          </FormItem>
        </Col>
      </Row>
      <Row ::gutter="16">
        <Col span="12">
          <FormItem label="公司名称"  prop="companyName">
            <Input   class="item-width" v-model="formData.companyName"></Input>
          </FormItem>
        </Col>
        <Col span="12">
          <FormItem label="入住人类型" prop="">
            <Select  class="width2" v-model="formData.stayPersonType">
              <Option value="">请选择</Option>
              <Option v-for="(item,index) in enumList.stayPersonType" :value="item.value" :key="'keyZ'+index">{{item.text}}</Option>
            </Select>

            <Select class="width2"  placeholder="年龄分布" v-model="formData.ageRange">
              <Option value="">请选择</Option>
              <Option v-for="(item,index) in enumList.ageRange" :value="item.value" :key="index+'keyF'">{{item.text}}</Option>
            </Select>
          </FormItem>
        </Col>
      </Row>
      <Row ::gutter="16">
        <Col span="12">
          <FormItem label="公司规模"  >
            <Select  class="item-width" v-model="formData.companyScale">
              <Option value="">请选择</Option>
              <Option v-for="item in enumList.companyScale" :value="item.value" :key="item.value">{{item.text}}</Option>
            </Select>
          </FormItem>
        </Col>
        <Col span="12">
          <FormItem label="付费主体" prop="">
            <Select  class="width2" v-model="formData.paySubject"
                     @on-change="changePaySubject">
              <Option value="">请选择</Option>
              <Option v-for="item in enumList.paySubjectList" :value="item.value" :key="item.value">{{item.text}}</Option>
            </Select>

            <Select class="width2"  placeholder="报销金额"  v-model="formData.reimbursementRange"
                    v-if="reimbursementRangeList2&& reimbursementRangeList2.length"

            >
              <Option value="">请选择</Option>
              <Option v-for="(item,index) in reimbursementRangeList2" :value="item.value" :key="'keyRa'+index">{{item.text}}</Option>
            </Select>
          </FormItem>
        </Col>
      </Row>

      <ul class="check" v-if="formData.businessFromChannel||formData.channelPhone||formData.channelNameAndCode||formData.businessMessage1">
        <!-- <div class="shu">渠道信息</div> -->
        <li v-if="formData.businessFromChannel">推荐渠道：{{formData.businessFromChannelText}}</li>
        <li v-if="formData.channelPhone">渠道人手机号：{{formData.channelPhone}}</li>
        <li v-if="formData.channelNameAndCode">渠道人信息：{{formData.channelNameAndCode}}</li>
        <li v-if="formData.businessMessage1">推荐客户需求描述：{{formData.businessMessage1}}</li>
      </ul>

<!--      <Row ::gutter="16">-->
<!--        <Col span="12">-->
<!--          <FormItem label="来源渠道" prop="businessFromChannel">-->
<!--            <Select v-model="formData.businessFromChannel" class="item-width" @on-change="formData.businessChannelInfo=''">-->
<!--              <Option value="">请选择</Option>-->
<!--              <Option v-for="item in conditions?conditions.channel:[]" :value="item.value" :key="item.value">{{item.text}}</Option>-->
<!--            </Select>-->
<!--          </FormItem>-->
<!--        </Col>-->

<!--        <Col span="12">-->
<!--          <FormItem label="渠道人信息"  v-if="['5','8','12','6'].indexOf(formData.businessFromChannel)!==-1">-->
<!--            <Input v-model="formData.businessChannelInfo" placeholder="请填写姓名和系统号"  class="item-width"></Input>-->
<!--          </FormItem>-->
<!--        </Col>-->
<!--      </Row>-->

      <Row>
        <Col span="12">
          <FormItem label="项目" prop="projectFid" class="">
            <!--            -->
            <Select v-model="formData.projectFid" class="item-width"
                    @on-change="changeProject"
            >
              <Option v-for="(item,index) in projectList" :value="item.value" :key="'keyPro'+index">{{item.text}}</Option>
            </Select>
          </FormItem>
        </Col>
        <Col span="12">
          <FormItem label="意向房型" prop="houseTypeFid">
            <Select v-model="formData.houseTypeFid" class="item-width">
              <Option value="">请选择</Option>
              <Option v-for="item in houseTypeFidList" :value="item.value" :key="item.value">{{item.text}}</Option>
            </Select>
          </FormItem>
        </Col>

      </Row>

      <Row ::gutter="16">
        <Col span="12">
          <FormItem label="期望入住时间" prop="intentionInTime">
            <DatePicker style="width:250px" v-model="formData.intentionInTime" :options="dateOption"  split-panels  format="yyyy-MM-dd" placeholder="期望入住时间"></DatePicker>
          </FormItem>

        </Col>
        <Col span="12">
          <FormItem label="预算范围" prop="budgetRange">
            <Select v-model="formData.budgetRange" class="item-width">
              <Option :value=0>请选择</Option>
              <Option v-for="item in enumList.budgetRange" :value="item.value" :key="item.value">{{item.text}}</Option>
            </Select>
            元/月
            <Tooltip v-if="logList.budgetRange" style="height:30px;display:inline-block;width:50px;margin-left:5px;" placement="top">
              <span class="red">更新记录</span>
              <div slot="content">
                <p v-for="(item,index) in logList.budgetRange" :key="index">
                  {{item.createDateStr}} {{item.createrName}}：{{item.newValueName}}
                </p>
              </div>
            </Tooltip>
          </FormItem>
        </Col>
      </Row>
      <Row ::gutter="16">
        <Col span="12">
          <FormItem label="几人居住" prop="checkinNum">
<!--            <Select v-model="formData.checkinNum" class="item-width">-->
<!--              <Option :value=0>请选择</Option>-->
<!--              <Option v-for="(item,index) in Array.apply(null,{length:enumList.liveNumber})" :value="index++" :key="index+'keyVV'">{{index++}}</Option>-->
<!--            </Select>-->
            <InputNumber class="item-width"  v-model="formData.checkinNum" :max="5000" :min="1" ></InputNumber>

            <Tooltip v-if="logList.checkinNum" style="height:30px;display:inline-block;width:50px;margin-left:5px;" placement="top">
              <span class="red">更新记录</span>
              <div slot="content">
                <p v-for="(item,index) in logList.checkinNum" :key="index">
                  {{item.createDateStr}} {{item.createrName}}：{{item.newValueName}}
                </p>
              </div>
            </Tooltip>
          </FormItem>
        </Col>
        <Col span="12">
          <FormItem label="找房意向户型" prop="houseType">
            <Select v-model="formData.houseType" class="item-width">
              <Option :value=0>请选择</Option>
              <Option v-for="item in enumList.houseType" :value="item.value" :key="item.value">{{item.text}}</Option>
            </Select>
            <Tooltip v-if="logList.houseType" style="height:30px;display:inline-block;width:50px;margin-left:5px;" placement="top">
              <span class="red">更新记录</span>
              <div slot="content">
                <p v-for="(item,index) in logList.houseType" :key="index">
                  {{item.createDateStr}} {{item.createrName}}：{{item.newValueName}}
                </p>
              </div>
            </Tooltip>
          </FormItem>
        </Col>
      </Row>
      <Row ::gutter="20">
        <Col span="12">
          <FormItem label="意向面积" prop="intentionArea">
            <Select v-model="formData.intentionArea" class="item-width">
              <Option :value=0>请选择</Option>
              <Option v-for="item in enumList.intentionArea" :value="item.value" :key="item.value">{{item.text}}</Option>
            </Select>
            <Tooltip v-if="logList.intentionArea" style="height:30px;display:inline-block;width:50px;margin-left:5px;" placement="top">
              <span class="red">更新记录</span>
              <div slot="content">
                <p v-for="(item,index) in logList.intentionArea" :key="index">
                  {{item.createDateStr}} {{item.createrName}}：{{item.newValueName}}
                </p>
              </div>
            </Tooltip>
            <!-- <Input v-model="formData.customerCompany" class="item-width"></Input> -->
          </FormItem>
        </Col>
        <Col span="12">
          <FormItem label="工作地点" prop="workAddressArr">
            <location ref="workaddress" :id="'workenterupdate'"></location>
          </FormItem>
        </Col>
      </Row>
      <Row ::gutter="16">
        <Col span="12">
          <FormItem class="zIndex" style="margin-bottom:0;float:left;margin-right:10px;z-index:99" label="期望租住时长" prop="rentPeriod">
            <Select v-model="formData.rentPeriod" @on-change="changeRentPeriod"
                    style="width: 182px;display: inline-block;z-index:99">
              <Option :value=0>请选择</Option>
              <Option :value=1>长租</Option>
              <Option :value=2>短租</Option>
            </Select>
          </FormItem>
          <FormItem label="" prop="rentNumber">
            <InputNumber v-if="formData.rentPeriod"  v-model="formData.rentNumber" :max="25" :min="0" style="width: 50px;"></InputNumber>
            <span v-if="formData.rentPeriod && formData.rentPeriod==1">年</span>
            <span v-if="formData.rentPeriod &&formData.rentPeriod==2">月</span>
          </FormItem>
        </Col>
        <Col span="12" v-if=" formData.rentPeriod &&formData.rentPeriod==2">
          <FormItem  label="短租用途" prop="clientType" >
            <Select v-model="formData.clientType"  class="item-width">
              <Option value="">请选择</Option>
              <Option v-for="item in enumList.shortRentDes" :value="item.value" :key="item.value">{{item.text}}</Option>
            </Select>
          </FormItem>
        </Col>
      </Row>
      <Row>

        <Col span="12">
          <FormItem label="通勤方式" prop="commutingMode">
            <Select v-model="formData.commutingMode"  class="item-width">
              <Option :value=0>请选择</Option>
              <Option v-for="item in enumList.commutingMode" :value="item.value" :key="item.value">{{item.text}}</Option>
            </Select>
          </FormItem>
        </Col>
        <Col span="12">
          <FormItem label="现住地点" >
            <location ref="residenceaddress" :id="'residenceenterupdate'"></location>

          </FormItem>
        </Col>
      </Row>
      <Row>

        <Col span="12">
          <FormItem label="期望通勤时长" prop="">
            <Select  v-model="formData.commutingDuration"  class="item-width">
              <Option :value=0>请选择</Option>
              <Option v-for="item in enumList.commutingDuration" :value="item.value" :key="item.value+'keyB'">{{item.text}}</Option>
            </Select>
          </FormItem>
        </Col>
        <Col span="12">
          <FormItem label="工作状态" prop="" >
            <Select v-model="formData.currentStatus"  class="item-width">
              <Option :value=0>请选择</Option>
              <Option v-for="item in enumList.currentStatus" :value="item.value" :key="item.value+'keyC'">{{item.text}}</Option>
            </Select>
          </FormItem>
        </Col>
      </Row>
<!--      <Row>-->
<!--          <Col span="12">-->
<!--            <FormItem label="商机等级" prop="grade">-->
<!--              <Select v-model="formData.grade"  class="item-width">-->
<!--                <Option v-for="item in conditions.grade" :value="item.text" :label="item.text" :key="item.text+'keyD'">-->
<!--                  <span>{{item.text}}</span>-->
<!--                  <span style="margin-left: 10px;color:#80848f">{{item.value}}</span>-->
<!--                </Option>-->
<!--              </Select>-->
<!--            </FormItem>-->
<!--          </Col>-->
<!--        </Row>-->
      <Row>
        <Col span="12">
          <FormItem label="处理结果" prop="result">
            <Cascader trigger="hover" :data="statusListMap" v-model="formData.result" @on-change="changeResult"
                      class="item-width"></Cascader>
          </FormItem>
        </Col>
        <Col span="12" style="padding-left: 15px">
          <FormItem class="ivu-form-item-required" label="是否带看" prop="isLook" v-if="showLookRadio">
            <RadioGroup v-model="formData.isLook">
              <Radio :label="0">
                <span>否</span>
              </Radio>
              <Radio :label="1">
                <span>是</span>
              </Radio>
            </RadioGroup>
            <div v-show="isLookError" class="error-tip">请选择是否带看</div>
          </FormItem>
        </Col>
        <Col span="8">
          <FormItem class="ivu-form-item-required" label="合同手机号" prop="contractPhone" v-if="showContract">
            <Input v-model="formData.contractPhone">
              <Button slot="append" icon="ios-search" @click="readContract"></Button>
            </Input>
            <div v-show="contractError" class="error-tip">请查询有效合同号</div>
          </FormItem>
        </Col>
        <Col span="4">
          <div  v-if="showContract" class="contract-code-box">{{formData.contractCode}}</div>
        </Col>
      </Row>
      <Row>
        <Col span="24">
          <FormItem :label="handleRecordLabel" prop="handleRecord">
            <Input type="textarea" :autosize="{minRows: 2}" :placeholder="handleRecordPlaceholder"
                   v-model="formData.handleRecord"></Input>
          </FormItem>
        </Col>
      </Row>
      <FormItem ref="appointVisit" class="ivu-form-item-required" label="带看时间" prop="appointVisitTime"
                v-if="showAvDatePicker">
        <DatePicker placement="top" :options="dateOption" ref="appointVisitTime" type="datetime"
                    format="yyyy-MM-dd HH:mm" v-model="formData.appointVisitTime"
                    @on-change="formData.appointVisitTime=$event" placeholder="yyyy-mm-dd HH:mm"
                    class="item-width"></DatePicker>
        <div v-show="avError" class="error-tip">请选择带看时间</div>
      </FormItem>
      <FormItem class="ivu-form-item-required" :label="lable" prop="returnVisitTime" v-if="showRvDatePicker">
        <DatePicker placement="top" :options="dateOption" ref="returnVisitTime" type="datetime"
                    format="yyyy-MM-dd HH:mm" v-model="formData.returnVisitTime"
                    @on-change="formData.returnVisitTime=$event" placeholder="yyyy-mm-dd HH:mm"
                    class="item-width"></DatePicker>
        <div v-show="rvError" class="error-tip">请选择{{lable}}</div>
      </FormItem>
    </Form>

    <div  class="text-align-c ">
      <Button type="text" size="large" @click="handleCancel" :disabled="!hasAuthority">取消</Button>
      <Button type="primary" size="large" @click="save" :loading="loadingButton" :disabled="!hasAuthority || !cansave">
        <span v-if="!loadingButton" >保存</span>
        <span v-else>保存中...</span>
      </Button>
    </div>


    <msg-tip :n="msgKey" :phoneStr="phoneStr" @cancelTimePick="cancelTimePick"></msg-tip>
    <cancel-modal :n = "cancelKey" @cancel="close" ></cancel-modal>
    <Tabs v-model="currentTab" class="toph-tabs">
      <TabPane label="跟进记录" name="HISTORY"></TabPane>
      <TabPane label="客户档案" name="PROFILE"></TabPane>
    </Tabs>
    <keep-alive>
    <div v-if="currentTab=='HISTORY'">
      <table-list
        title=""
        :columns="columns"
        :data="tabelData"
        :loading="tableLoading"
        :showPage = "false"
      ></table-list>
    </div>
    </keep-alive>
    <keep-alive>
      <div v-if="currentTab=='PROFILE'">
        <table-list
          title="浏览记录"
          :columns="browseColumns"
          :data="browseTabelData"
          :loading="browseTableLoading"
          :current="browseCurrent"
          :total="browseTotal"
          @change-page="browseChangPage"
          :pageSize="5"
        ></table-list>

        <table-list
          title="收藏信息"
          :columns="collecitonColumns"
          :data="collectionTabelData"
          :loading="collectionTableLoading"
          :current="collectionCurrent"
          :total="collectionTotal"
          @change-page="collectionChangPage"
        ></table-list>

        <table-list
          title="历史合同"
          :columns="contractColumns"
          :data="contractTabelData"
          :loading="contractTableLoading"
          :showPage = "false"
        ></table-list>
      </div>
    </keep-alive>
    <div slot="footer"></div>
  </Modal>
</template>
<script type="text/ecmascript-6">

  import {
    getSelectedData,
    getDetail,
    getHandleList,
    handleBusiness,
    getContractCode,
    isHaveLookBusiness,
    getContractHistory,
    getBrowseHistory,
    getCollectionHistory,
    getAreaRegionByProjectFid,
    getCustomerPortraitLog,
    getAllBusinessRecords
  } from 'api/business'
  import { getProjectHouseType } from 'api/common'
import { formatDateTime } from '@/utils/format'
import TableList from 'components/TableList/index';
import CancelModal from 'components/CancelModal/index';
import MsgTip from './MsgTip';
import Location from 'components/Location/index'
  import {mapGetters} from 'vuex'

export default {
  props:{
    data: {
      type: Object,
      default: null
    },
    conditions:{
      type:Object,
      default:null
    },
    enumList:{
      type:Object,
      default:null
    },
    n:{
      type:Number,
      default:0
    },
    // projectFid:{
    //   type:String,
    //   default:''
    // },
    uid:{
      type:String,
      default:''
    },
    statusList:{
      type:Array,
      default:()=>{
        return []
      }
    },
    zoFid:{
      type:String,
      default:''
    },

  },
  components: {
    TableList,
    MsgTip,
    CancelModal,
    Location
  },
  watch:{
   n(val){

     this.currentTab = "HISTORY"
     this.loading =false
     this.loadingButton = false
     this.show = true;
     this.formData.result= []
     this.showAvDatePicker = false
     this.showRvDatePicker = false
     this.showContract = false
     // this.disabled =false
     this.showLookRadio = false
     this.workAddressArr = [];
     this.residenceArr = []
     this.$refs['formData'] && this.$refs['formData'].resetFields();
     this.$refs['workaddress'] &&  this.$refs['workaddress'].resetData()
     this.$refs['residenceaddress']&&  this.$refs['residenceaddress'].resetData()
     this.hasAuthority=true


     this.browseCurrent = 1
     this.browseTotal = 0
     this.collectionCurrent = 1
     this.collectionTotal = 0
     this.browseTableLoading = false
     this.collectionTableLoading = false
     this.contractTableLoading = false
     this.browseTabelData = []
     this.collectionTabelData = []
     this.contractTabelData = []


     this.tabelData=[]

     this.formData={
       appointVisitTime: '',
         budgetPriceRange: '',
         businessFid: '',
         businessMessage: '',
         contractCode: '',
         contractPhone:'',
         customerCompany: '',
         customerGender: '',
         clientType: '',
         customerName: '',
         customerPhone: '',
         expectCheckinTime: '',
         expectVisitTime: '',
         handleRecord: '',
         handleResult: '',
         handleStatus: '',
         houseTypeFid: '',
         isLook: '1',
         projectFid: '',
         returnVisitTime: '',
         result:[],
         rentPeriod:'',
         rentNumber:null,
         handleDetailMsg:'',
         businessFromPlatform: 0,
         channelPhone: '',
         channelNameAndCode: '',
         intentionInTime:'',
         budgetRange:'',
         checkinNum:null,
         intentionArea:'',
         commutingMode:'',
         houseType:'',
         grade: ''
     }
     if(this.data&& this.data.businessFid){
       this.initData(this.data.businessFid)

     }
     if(this.data && this.data.customerUid){
       this.getLogs(this.data.customerUid)
     }
    },
    // projectFid(val) {
    //   this.getHouseType(val)
    // },
    "formData.customerPhone":{
      handler(val){
        this.formData.contractPhone = val
      }
    },
    workAddressArr(val){
      if(val.length>0){
        if(val[0]){
          this.formData.workAddressArea = val[0]
          this.formData.workAddress = ''
        }
        if(val[1]){
          this.formData.workAddress = val[1]
        }
      } else{
        this.formData.workAddressArea = '';
        this.formData.workAddress = ''
      }
    },
    residenceArr(val){
      if(val.length>0){
        if(val[0]){
          this.formData.residenceArea = val[0]
        }
        if(val[1]){
          this.formData.residence = val[1]
        }
      } else{
        this.formData.residenceArea = '';
        this.formData.residence = ''
      }
    }
  },
    data () {
    const validateRentNumber = (rule, value, callback) => {
      if(this.formData.rentPeriod){
        if(!value){
          callback(new Error('请输入期望租住时长'));
        } else{
          callback();
        }
      }
        callback();
      }
    const validatecontactPhone = (rule, value, callback) => {
      // let pattern = /^1(\d+){10}$/
      const pattern = /^\d+$/
      if(!pattern.test(value)){
        callback(new Error('输入正确的联系方式'));
      }
      callback();
    }
    return {
      logList:{},
      dateOption: {
        disabledDate (date) {
          return date && date.valueOf() < Date.now() - 86400000;
        }
      },
      currentTab:"HISTORY",
      cansave:true,
      cancelKey:0,
      hasAuthority: true,
      initAvDate:'',
      msgKey:0,
      phoneStr:'',
      show:false,
      loadingButton:false,
      loading:false,
      businessDetail:null,
      lable:'跟进时间',
      handleRecordLabel: '跟进记录',
      handleRecordPlaceholder: '租住人数、特殊需求记录，最多输入150字',
      showAvDatePicker:false,
      showRvDatePicker:false,
      showContract:false,
      avError:false,
      rvError:false,
      isLookError:false,
      contractError:false,
      // disabled:false,
      showLookRadio:false,
      showHistoryKey:0,
      tableLoading:true,
      contract:'',
      businessMessage:null,
      columns:[
        {
          title: '跟进时间',
          key: 'followUpTime',
          align: 'center',
          width:160
        },
        {
          title: '跟进人',
          key: 'followUpUser',
          align: 'center',
          width:80
        },
        {
          title: '跟进结果',
          key: 'followUpResult',
          align: 'center',
        },
        {
          title: '备注',
          key: 'remark',
          align: 'center',
          render: (h, params) => {
            if (params.row['remark'] && params.row['remark'].length > 40) {
              return h('Tooltip', {
                props: {
                  placement: "top"
                }
              }, [
                h('div', {
                  style: {
                    whiteSpace: 'normal'
                  },
                  slot: 'content',
                }, params.row['remark']),
                h('div', {
                  style:
                    {'line-height':'25px !important'}
                },  params.row['remark'].slice(0, 40) + '...')
              ])
            } else {
              return h('div', {}, params.row['remark'])
            }

          }
        }
      ],
      // businessRecordColumns:[
      //   {
      //     title: '创建时间',
      //     key: 'createTime',
      //     align: 'center',
      //     width:110
      //   },
      //   {
      //     title: '看房时间',
      //     key: 'visitTime',
      //     align: 'center',
      //     width:110
      //   },
      //   {
      //     title: '意向房型',
      //     key: 'houseType',
      //     align: 'center',
      //     width:120
      //   },
      //   {
      //     title: '来源渠道',
      //     key: 'businessChannel',
      //     align: 'center',
      //     width:110
      //   },
      //   {
      //     title: '用户留言',
      //     key: 'businessMessage',
      //     align: 'center',
      //   }
      // ],
      tabelData:[],
      formData:{
        appointVisitTime: '',
        budgetPriceRange: '',
        businessFid: '',
        businessMessage: '',
        contractCode: '',
        contractPhone:'',
        customerCompany: '',
        customerGender: '',
        clientType: '',
        customerName: '',
        customerPhone: '',
        expectCheckinTime: '',
        expectVisitTime: '',
        handleRecord: '',
        handleResult: '',
        handleStatus: '',
        houseTypeFid: '',
        isLook: '1',
        projectFid: '',
        returnVisitTime: '',
        result:[],
        rentPeriod:'',
        rentNumber:null,
        handleDetailMsg:'',
        businessFromPlatform: 0,
        channelPhone: '',
        channelNameAndCode: '',
        intentionInTime:'',
        budgetRange:'',
        checkinNum:null,
        intentionArea:'',
        commutingMode:'',
        houseType:'',
        grade: ''
      },
      chanelList:[],
      residenceArr:[],
      workAddressArr:[],
      houseTypeFidList:[],
      formRules:{

        companyName: [{required: true, message: '请输入公司名称', trigger: 'blur', type: 'string'}],
        customerName:[{ required: true, message: '请输入客户姓名' ,trigger: 'blur', type:'string'}],
        customerPhone:[ {required:true, validator: validatecontactPhone, trigger: 'blur'}],
        result:[ {required:true, message: '请选择处理结果', trigger: 'change', type:'array'}],
        rentNumber:[{ required: true,validator: validateRentNumber,trigger: 'change'}],
        // businessFromChannel: [{required: true, message: '请输选择来源渠道', trigger: 'change', type: 'string'}],
        handleRecord:[ {required:true, message: '请填写备注或跟进记录', trigger: 'blur', type:'string'},{validator: this.handleRecordIsLength, trigger: 'blur'}],
        // grade:[ {required:true, message: '请选择商机等级', trigger: 'change', type:'string'}]
      },
      disabledIsLook:null,

      //客户档案
      customerUid:'',
      browseTableLoading:true,
      collectionTableLoading:true,
      contractTableLoading:true,
      businessRecordsTableLoading:true,
      browseCurrent:1,
      browseTotal:0,
      collectionCurrent:1,
      collectionTotal:0,
      browseColumns:[
        {
          title: '浏览对象',
          key: 'browseMsg',
          align: 'center'
        },
        {
          title: '最近浏览时间',
          key: 'browseLatelyTimeStr',
          align: 'center'
        },
        {
          title: '浏览次数',
          key: 'browseTotalCount',
          align: 'center'
        }
      ],
      collecitonColumns:[
        {
          title: '收藏对象',
          key: 'collectionObjName',
          align: 'center'
        },
        {
          title: '收藏时间',
          key: 'collectionTimeStr',
          align: 'center'
        }
      ],
      contractColumns:[
        {
          title: '项目名称',
          key: 'projectName',
          align: 'center',
          width:200
        },
        {
          title: '房间名称',
          key: 'roomName',
          align: 'center',
          width:100
        },
        {
          title: '合同开始日期',
          key: 'startDateStr',
          align: 'center',
          width:160
        },
        {
          title: '合同截止日期',
          key: 'endDateStr',
          align: 'center',
          width:160
        },
        {
          title: '月租金',
          key: 'amount',
          align: 'center',
          width:160
        },
        {
          title: '合同状态',
          key: 'contractStatus',
          align: 'center',
          width:100
        },
        {
          title: '合同来源',
          key: 'type',
          align: 'center',
          width:100
        }
      ],
      browseTabelData:[],
      collectionTabelData:[],
      contractTabelData:[],
      // businessRecordsTableData:[],
    };
 },
 computed:{
   reimbursementRangeList2(){

     if(!(this.formData.paySubject+'')){
       return []

     }
     const map={}
     this.enumList.paySubjectList.forEach(ele=>{
       if(ele.reimbursementRangeList){
         map[ele.value+'']=ele.reimbursementRangeList

       }
     })
     return map[this.formData.paySubject+'']||[]

   },
   ...mapGetters(['projectList']),

   visitTimeLable() {
     return this.formData.appointVisitTime ? '更改带看时间' : '带看时间'
   },
   statusListMap(){
     function f(data) {
       data && data.forEach(ele=>{
         ele['label']=ele['text']

         if(ele['children']){
           f(ele['children'])
         }
       })

     }
     if( !this.statusList){
       return []
     }
     f(this.statusList)
     return this.statusList

   }
 },
 methods:{
   changePaySubject(){
     if(!this.reimbursementRangeList2.length){
       this.formData.reimbursementRange=''
       return

     }
     if(this.formData.reimbursementRange+''){
       const list=this.reimbursementRangeList2.map(ele=>{return ele.value})
       if(list.indexOf(this.formData.reimbursementRange)===-1){
         this.formData.reimbursementRange=''

       }

     }

   },
   getLogs(uid){
     getCustomerPortraitLog({uid:uid}).then( res => {
       this.logList = res.data?res.data:{};
     })
   },
   changeProject(val) {
     if(!val){
       this.houseTypeFidList=[]
       return

     }

     getProjectHouseType(val).then(res => {
       this.houseTypeFidList = res.data?res.data:[]

       if(this.formData.houseTypeFid){
        const ids= this.houseTypeFidList.map(ele=>{
         return ele.value
         })
         if(ids.indexOf(this.formData.houseTypeFid)===-1){
           this.formData.houseTypeFid=''
         }
       }
     }).catch(error=>{
       this.formData.houseTypeFid=''

     })
     // this.workAddressArr = []
     // this.residenceArr = []
     // this.getRegion(val);
   },
   cancelTimePick(){
     this.formData.appointVisitTime = this.initAvDate
   },
  checkTime(val){
   if(val) {
     this.cansave = false
   } else {
     this.cansave = true
   }
    if(typeof this.formData.appointVisitTime=='object' && this.formData.appointVisitTime !== null) {
      this.formData.appointVisitTime = formatDateTime(this.formData.appointVisitTime)
    }
    const data = {
      businessFid:this.businessFid,
      businessLookDate: this.formData.appointVisitTime,
      zoFid: this.zoFid
    }
    if(!val && this.formData.appointVisitTime) {
      isHaveLookBusiness(data).then(res => {
      if (res.data.lookBusinessCustomerPhone) {
        this.phoneStr = res.data.lookBusinessCustomerPhone
        this.msgKey++
      }
    })
    }

  },
  changeResult(value,selectedData){
      this.resetHideData()
      this.result = selectedData.length === 1 ? '' : selectedData[1].text
      const firstResult = value[0]
      this.lable = firstResult == 1 ? '跟进时间': '回访时间'
      this.showContract  = (firstResult == 4 || firstResult == 7) ? true : false
      this.showLookRadio = firstResult == 5 ? true : false
      this.showAvDatePicker = firstResult == 2 ? true : false
      this.showRvDatePicker = firstResult == 1 || firstResult == 3? true : false
      if (firstResult == 4) {
          this.handleRecordLabel = '签约备注';
          this.handleRecordPlaceholder ='商机成交的房源/公寓原因、客户原因记录，最多输入150个字';
      } else if (firstResult == 5) {
          this.handleRecordLabel = '丢单备注';
          this.handleRecordPlaceholder ='商机未成交的房源/公寓原因、客户原因记录，最多输入150个字';
      } else {
          this.handleRecordLabel = '跟进记录';
          this.handleRecordPlaceholder ='租住人数、特殊需求记录，最多输入150字';
      }
  },
    resetHideData(){
      // this.formData.appointVisitTime =''
      this.formData.returnVisitTime = ''
      this.formData.contractCode = ''
      this.formData.handleDetailMsg = ''
      // this.formData.isLook = ''
      this.avError = false
      this.rvError = false
      this.isLookError = false
      this.contractError = false
      // this.disabled = false
    },
    getResultStr(code){
      let str = ''
      let split = '-'
      let detailmsg = ''

      switch(code) {
        case '1' :
          str = `跟进时间:${this.formData.returnVisitTime}`
          break;
        case '2':
          str = `带看时间:${this.formData.appointVisitTime}`
          break;
        case '3':
          str = `回访时间:${this.formData.returnVisitTime}`
          break;
        case '4':
          str = `合同号:${this.formData.contractCode}`
          break;
        case '5':
          str = this.formData.isLook ===0?'未带看' :'已带看'
          detailmsg = `${this.formData.handleDetailMsg}`
          break;
      }
      if(code == 6) { split = '' }
      if(detailmsg) {
          detailmsg = '/'+detailmsg
      }
      return this.result =='' ? detailmsg+str : this.result+ detailmsg + split +str
    },
    initData(businessFid) {
      getDetail(businessFid).then(res => {
        this.businessDetail = res.data
        const data = res.data
        this.initAvDate = res.data.appointVisitTime;
        this.disabledIsLook = res.data.isLook;
        this.customerUid = res.data.customerUid;
        if(res.data.isLook === 1){
          this.formData.isLook = 1;
        }
        for(const key in data) {
          this.formData[key] = data[key]
          this.formData.handleRecord = ''
        }
        this.workAddressArr = [this.formData.workAddressArea,this.formData.workAddress];
        this.residenceArr = [this.formData.residenceArea,this.formData.residence]

        if (this.formData.customerGender == 1) {
          this.formData.customerGenderText = '女'
        } else if (this.formData.customerGender == 2) {
          this.formData.customerGenderText = '男'
        } else {
          this.formData.customerGenderText = ''
        }

        this.$refs['workaddress']&& this.$refs['workaddress'].setData(
          {
            cityCode:data['workAddressCity']   ,
            regionCode:data['workAddressArea'],
            address: data['workAddressDesc'],
            lon:data['workAddressLon'],
            lat:data['workAddressLat'],
          }
        )
        this.$refs['residenceaddress'] && this.$refs['residenceaddress'].setData(
          {
            cityCode:data['residenceCity'],
            regionCode:data['residenceArea'],
            address:data['residenceDesc'],
            lon:data['residenceLon'],
            lat: data['residenceLat']

          }
        )
        // this.formData.workAddressText = this.formData.workAddress;
        // this.formData.residenceText = this.formData.residence;

      }).catch(res=> {
        this.hasAuthority = false
      })

      getHandleList(businessFid).then( res => {
        this.tabelData = res.data.rows
        this.tableLoading = false
      }).catch(error=>{
        this.tableLoading = false
      })

    },
    // getHouseType(projectFid){
    //   getProjectHouseType(projectFid).then( res => {
    //     this.houseTypeFidList = res.data
    //   })
    // },
    changeLoading() {
      this.loading = false;
      this.$nextTick(() => {
          this.loading = true
      })
    },
    readContract(){
      if (!this.formData.contractPhone) {
        this.formData.contractPhone = this.formData.customerPhone
      }
      if(this.formData.customerPhone !== '') {
        getContractCode({
          phone: this.formData.contractPhone,
          projectFid: this.formData.projectFid,
          status: this.formData.result[0]
        }).then(res => {
          if (res.data) {
            this.formData.contractCode = res.data
            // this.disabled = true
          }else {
            this.formData.contractCode = null
            this.$Message.info('未查询到有效的合同号！')
          }

        })
      } else {
        this.$Message.error('请输入有有效的手机号')
      }
    },
    handleCancel(){
      this.cancelKey ++

    },
    close() {
      this.show = false
    },

    validateHideData(){
      if (this.formData.result .length <1) return true
      const status = this.formData.result[0]
      this.avError = status == 2 && (this.formData.appointVisitTime === '' || this.formData.appointVisitTime === null )? true :false
      this.rvError = (status == 1 || status == 3) && this.formData.returnVisitTime === '' ? true :false
      this.isLookError = status == 5 && this.formData.isLook === '' ? true :false
      this.contractError = status == 4 && this.formData.contractCode === '' ? true :false
      // console.log(avError,rvError,isLookError)
      return !(this.avError || this.rvError || this.isLookError || this.contractError)
    },

    save(){
      const data = {}
       if(typeof this.formData.appointVisitTime=='object' && this.formData.appointVisitTime !== null) {
        this.formData.appointVisitTime = formatDateTime(this.formData.appointVisitTime)
        }
      if(typeof this.formData.returnVisitTime=='object' && this.formData.returnVisitTim !== null ) {
        this.formData.returnVisitTime = formatDateTime(this.formData.returnVisitTime)
      }

      this.$refs["formData"].validate(bool => {
        if  (bool && this.validateHideData()) {
          if (this.showContract && !this.formData.contractCode) {
            this.$Message.error("请根据手机号查询有效的合同")
            return
          }
          this.loadingButton = true
          for (const key in this.formData) {
            if (key==='result'){
              continue;
            } else if (key==='handleStatus') {
              data[key] = this.formData.result[0]
            } else if (key==='handleResult') {
              data[key] = this.getResultStr(this.formData.result[0])
            } else {
              data[key] = this.formData[key]
            }
          }

          if(this.formData.result[0] != '2')  {
            data.appointVisitTime = ''
          }
          if(this.formData.result[0] == 1){
            data.twoLevelhandleResult = this.formData.result[1]
          }
          // data.projectFid = this.projectFid

          //地点调整
          const workdata=this.$refs['workaddress'].data
          data['workAddressCity']=workdata.cityCode
          data['workAddressArea']=workdata.regionCode
          data['workAddressDesc']=workdata.address
          data['workAddressLon'] = workdata.lng
          data['workAddressLat'] = workdata.lat

          const  residenceaddress=this.$refs['residenceaddress'].data
          data['residenceCity']=residenceaddress.cityCode
          data['residenceArea']=residenceaddress.regionCode
          data['residenceDesc']=residenceaddress.address
          data['residenceLon']= residenceaddress.lng
          data['residenceLat']= residenceaddress.lat


          handleBusiness(data).then( res=> {
            this.$Message.success('处理成功');
            this.changeLoading()
            this.$emit('refresh')
            this.show=false
          }).catch( () => {
            // this.changeLoading()
            this.show = false
          }).finally(()=>{
            this.loadingButton = false
          })
        }else {
          this.loadingButton = false
        }
      });
    },
    showHistory(){
      this.$emit('showHistory')
    },

   changeRentPeriod(value) {
          if(value==1 && this.formData.rentNumber==-1) {
            this.formData.rentNumber = null
          }else if(value==2 && this.formData.rentNumber==-1){
            this.formData.rentNumber = null
          }else if(value == 0) {
            this.formData.rentNumber = null
            this.formData.rentPeriod = 0
          }

   },
   //客户档案
   browseChangPage(n){
     this.browseTableLoading = true;
     this.browseCurrent = n;
     this.initBrowseTableList(this.customerUid,n,5);
   },
   initBrowseTableList(customerUid,page,limit) {
     getBrowseHistory(customerUid,page,limit).then( res => {
         if(res.code==0) {
           this.browseTabelData = res.data.rows
           this.browseTotal = res.data.total
         }else {
           this.$Message.warning(res.message);
         }
       this.browseTableLoading = false
     }).catch(()=>{
       this.browseTableLoading = false
     });
   },
   collectionChangPage(n){
     this.collectionTableLoading = true;
     this.collectionCurrent = n;
     this.initCollectionTableList(this.customerUid,n,5);
   },
   initCollectionTableList(customerUid,page,limit) {
     getCollectionHistory(customerUid,page,limit).then( res => {
         if(res.code==0) {
           this.collectionTabelData = res.data.rows
           this.collectionTotal = res.data.total
         }else {
           this.$Message.warning(res.message);
         }
       this.collectionTableLoading = false
     }).catch(()=>{
       this.collectionTableLoading = false
     });
   },
   initContractTableList(customerUid) {
     getContractHistory(customerUid).then( res => {
         if(res.code==0) {
           this.contractTabelData = res.data
         }else {
           this.$Message.warning(res.message);
         }
       this.contractTableLoading = false
     }).catch(()=>{
       this.contractTableLoading = false
     });
   },
   initProfile(customerUid) {
     this.initContractTableList(customerUid);
     this.initCollectionTableList(customerUid,1,5);
     this.initBrowseTableList(customerUid,1,5);
   },
   handleRecordIsLength(rule, value, callback) {
     if(value.split(" ").join("").length === 0){
       callback(new Error('备注或者跟进记录不能全为空格'));
     }
     value = value.replace(/\s*/g,"")
     const enc = new TextEncoder("utf-8");
        if(value==''||value==undefined||value==null) {
            callback();
        } else if (enc.encode(value).length<12) {
          callback(new Error('备注或者跟进记录除空格外，汉字不能少于4，字符不能少于12'));
        } else if (value.length>150) {
            callback(new Error('备注或者跟进记录字数不能超过150'));
        } else {
            callback();
        }
   },
  }
}
</script>
<style scoped>
  .item-width {
    width: 250px;
  }
  .width2{
    width: 120px;
  }

.icon-wrap {
  display: inline;
}
.half-w {
  width: 50%;

}
.error-tip {
  position: absolute;
  color: #F56356;
}
.ivu-date-picker {
  width: 100%;
}
.old{
  color: red;
  line-height: 18px;
}
.red{
  color: #CFA868;
  display: inline-block;
  width: 80px;
}
.check{
  width: 95%;
  margin-left: 16px;
  border:1px dashed;
  padding: 16px 16px 0 30px;
  background: #eee;
  margin-bottom: 20px;
  position: relative;
}
.check li{
  width: 46%;
  margin-bottom:16px;
  display: inline-block;
}
.shu{
  width: 20px;
  position: absolute;
  height: 80px;
  left: 5px;
  top: 6px;

}
.readOnly div{
  width: 47%;
  margin-bottom:16px;
  margin-left:16px;
  display: inline-block;
}
.marB0{
  margin-bottom: 0;
}
  .check{
    width: 95%;
    margin-left: 16px;
    border:1px dashed;
    padding: 16px 16px 0 30px;
    background: #eee;
    margin-bottom: 20px;
    position: relative;
  }
  .check li{
    width: 46%;
    margin-bottom:16px;
    display: inline-block;
  }

.contract-code-box {
  line-height: 32px;
  font-weight: bolder;
}
</style>
<style>
  .zIndex .ivu-form-item-content{
    z-index: 99;
  }
</style>

